import { useEffect, useState } from 'react';
import { useCookieConsent } from '../CookieConsentProvider';
import { ga } from '../../config';

export const GoogleAnalyticsTracking = ({ initialize, pageview, location }) => {
  const consent = useCookieConsent();

  const [initialized, setInitalized] = useState(false);

  useEffect(() => {
    const setInit = () => setInitalized(true);

    if (consent.status === 'accepted') {
      if (!initialized) {
        initialize(ga.trackingId, { ...ga.options });
        setInit();
      }
      pageview(`${location.pathname}${location.search}`);
    }
  }, [
    consent.status,
    initialize,
    pageview,
    location.pathname,
    location.search,
    initialized
  ]);

  return null;
}